import type { Gate, Runway, ZoneDef } from "../state/types";

/**
 * Создать свежий массив ВПП с начальным снегом и нулевым occupancy.
 * Мутабельное состояние смены — не шарить между партиями.
 */
export function createRunways(): Runway[] {
  return [
    {
      id: 0,
      name: "09L · главная",
      x1: 210,
      x2: 1395,
      y: 252,
      w: 70,
      snow: 22,
      ice: 0,
      plane: null,
      closed: false,
      alert: 0,
      snowCool: 0,
      critArmed: true,
      clearX: 0,
      reservedFor: null,
      reserveT: 0,
      reserveLabel: "",
      tempCloseT: 0,
      clearSnowT: 0,
      clearIceT: 0,
      clearSnowMax: 0,
      clearIceMax: 0,
    },
    {
      id: 1,
      name: "27R · вторая",
      x1: 210,
      x2: 1395,
      y: 452,
      w: 70,
      snow: 8,
      ice: 0,
      plane: null,
      closed: false,
      alert: 0,
      snowCool: 0,
      critArmed: true,
      clearX: 0,
      reservedFor: null,
      reserveT: 0,
      reserveLabel: "",
      tempCloseT: 0,
      clearSnowT: 0,
      clearIceT: 0,
      clearSnowMax: 0,
      clearIceMax: 0,
    },
  ];
}

/**
 * Создать свежий массив гейтов (без занятых бортов).
 */
export function createGates(): Gate[] {
  return [
    { id: 0, name: "A1", x: 470, y: 672, plane: null },
    { id: 1, name: "A2", x: 672, y: 672, plane: null },
    { id: 2, name: "B1", x: 874, y: 672, plane: null },
    { id: 3, name: "B2", x: 1076, y: 672, plane: null },
  ];
}

/**
 * Создать определения зон накопления снега (геометрия ZONE_DEFS).
 * Runtime-поля (snow/ice/…) добавляются при старте смены отдельно.
 */
export function createZoneDefs(): ZoneDef[] {
  return [
    {
      id: "rwy0",
      name: "09L · главная",
      x: 210,
      y: 220,
      w: 1185,
      h: 70,
      kind: "rwy",
      rwy: 0,
    },
    {
      id: "rwy1",
      name: "27R · вторая",
      x: 210,
      y: 420,
      w: 1185,
      h: 70,
      kind: "rwy",
      rwy: 1,
    },
    {
      id: "taxi",
      name: "Рулежки",
      x: 200,
      y: 560,
      w: 1240,
      h: 50,
      kind: "taxi",
    },
  ];
}
